import React, { useRef, useEffect, useState } from "react";

import Navmenu from "./Navmenu";
import { menuItems } from "@/constant/data";
import useSemiDark from "@/hooks/useSemiDark";
import { Link } from "react-router-dom";
import useMobileMenu from "@/hooks/useMobileMenu";
import Icon from "@/components/ui/Icon";
import SimpleBar from "simplebar-react";
import BrandWordmark from "@/components/ui/BrandWordmark";

const MobileMenu = () => {
  const scrollableNodeRef = useRef(null);
  const [scroll, setScroll] = useState(false);

  useEffect(() => {
    const el = scrollableNodeRef.current;
    if (!el) return undefined;
    const handleScroll = () => {
      setScroll(el.scrollTop > 0);
    };
    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, []);

  const [isSemiDark] = useSemiDark();
  const [, setMobileMenu] = useMobileMenu();

  return (
    <div
      className={`${isSemiDark ? "dark" : ""} flex h-full w-full flex-col border-r border-stone-200 bg-stone-50 shadow-2xl dark:border-slate-700 dark:bg-slate-950`}
    >
      <div className="flex shrink-0 items-center justify-between gap-3 border-b border-stone-200 px-4 py-4 dark:border-slate-800">
        <Link
          to="/dashboard"
          onClick={() => setMobileMenu(false)}
          className="min-w-0 outline-none rounded-lg focus-visible:ring-2 focus-visible:ring-teal-500/60"
        >
          <BrandWordmark variant="sidebar" asLink={false} />
        </Link>
        <button
          type="button"
          onClick={() => setMobileMenu(false)}
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-stone-200 bg-white text-slate-600 transition hover:bg-stone-100 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300 dark:hover:bg-slate-800"
          title="Close menu"
        >
          <Icon icon="heroicons:x-mark" className="text-xl" />
        </button>
      </div>

      <div
        className={`pointer-events-none absolute left-0 right-0 top-[72px] z-[1] h-10 transition-opacity duration-200 ${
          scroll ? "opacity-100" : "opacity-0"
        }`}
        style={{
          background:
            "linear-gradient(to bottom, rgba(15,23,42,0.06), transparent)",
        }}
      />

      <SimpleBar
        className="min-h-0 flex-1 px-3 py-3"
        scrollableNodeProps={{ ref: scrollableNodeRef }}
      >
        <Navmenu menus={menuItems} />
      </SimpleBar>
    </div>
  );
};

export default MobileMenu;
